import { styled, Tooltip, tooltipClasses } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { AiOutlineEye } from "react-icons/ai";
import { Row } from "reactstrap";
import {
  FEE_COMPONENTS,
  getProgressiveConcessionListWithCustom,
  getValidConcessionAmount,
} from ".";
import MuiTable from "../../../../common/commonComponents/MuiTable";
import moment from "moment";
import { failureToast } from "../../../../common/utils/methods/toasterFunctions/function";
import CategorySelector from "./categorySelector";
import { useParams } from "react-router";
import { SupportingDocUploader } from "./upload";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import RemarksDialogue, {
  fetchRemarks,
} from "../../../concessionApproval/RemarksDialogue";
import {
  getCurrentStatus,
  getExtraCompValue,
  isAlreadyAboveLimit,
  isNewTermStudent,
} from "./common";
import { NEW_APPROVAL_STATUS, STATUS_DATA } from "./constants";
import { getFormatedDateTime } from "./discretionary";
import CategoryDetailsCard from "./CategoryDetailsCard";
import { calculateOutstanding } from "../feeBreakup/common";
import CommonInput from "views/pages/manage/common/formFeilds/input/commonInput";
import { regex } from "../../../../common/constant";
import AppliedConcessionSummary from "./AppliedConcessionSummary";
export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    maxWidth: "1000px",
  },
}));

const getConcessionPercent = (row, fee) => {
  const value =
    row?.orgTutionFeeConcession ||
    row?.tutionFeeConcession ||
    row?.classFeeConcession ||
    0;

  // If concession is AMOUNT → convert to %
  if (row?.concessionParameter === "AMOUNT") {
    return fee?.tutionFee ? ((value / fee.tutionFee) * 100).toFixed(2) : 0;
  }

  return value;
};

const ScholarshipComp = (params) => {
  const { id, value, field, row, feeComps, extraComponent, fee } = params;
  const { isNewSlab } = row;
  const extraComponentVal = getExtraCompValue(
    row.tutionFeeConcession,
    row.adminFeeConcession,
    row.regFeeConcession,
    row.classFeeConcession,
    row.techFeeConcession
  );

  //console.log(extraComponent)
  const getViewOnlyVal = (val, componentName) => {
    return val === 0 && extraComponent.find((item) => item === componentName)
      ? extraComponentVal && parseFloat(extraComponentVal?.toFixed(2))
      : val && parseFloat(val?.toFixed(2));
  };

  const values = (
    <>
      {FEE_COMPONENTS.map((item) => {
        const orgKey =
          "org" + item.beName.charAt(0).toUpperCase() + item.beName.slice(1);

        const valueToUse =
          // row[orgKey] !== undefined && row[orgKey] !== null
          !isNewSlab ? row[orgKey] : row[item.beName];

        const value = getViewOnlyVal(valueToUse, item.value);

        let percentVal, amountVal;
        if (row.concessionParameter === "AMOUNT") {
          amountVal = getValidConcessionAmount(value, fee[item.feeName]);
          percentVal = ((amountVal * 100) / fee[item.feeName]).toFixed(2);
          percentVal = percentVal > 0 ? percentVal : 0;
        } else {
          percentVal = value;
          amountVal = ((fee[item.feeName] * percentVal) / 100).toFixed(2);
        }

        return (
          <div className={value > 0 ? "font-weight-bold" : ""}>
            {item.label}: {`${percentVal}% (₹${amountVal})`}
          </div>
        );
      })}
    </>
  );

  return (
    <div className="w-100 d-flex">
      <LightTooltip title={values}>
        <span style={{ color: "#00B0F5", cursor: "pointer" }}>View</span>
      </LightTooltip>
    </div>
  );
};

const ViewProgressiveConcessionBreakup = (params) => {
  const { id, value, field, row, feeComps, extraComponent, fee } = params;
  const values = (
    <>
      {FEE_COMPONENTS.map((item) => {
        // const { progressiveConcessionPercent, progressiveAmount } =
        //   row?.progressiveConcession?.[item.feeName];
        const progressiveConcessionPercent = row[`${item.feeName}Concession`];
        // debugger
        const progressiveAmount = (
          (fee[item.feeName] * progressiveConcessionPercent) /
          100
        ).toFixed(2);
        return (
          <div className={value > 0 ? "font-weight-bold" : ""}>
            {item.label}:{" "}
            {`${progressiveConcessionPercent}% (₹${progressiveAmount})`}
          </div>
        );
      })}
    </>
  );

  return (
    <div className="w-100 d-flex">
      <LightTooltip title={values}>
        <span style={{ color: "#00B0F5", cursor: "pointer" }}>View</span>
      </LightTooltip>
    </div>
  );
};

const getFormatedDate = (date) => {
  return date ? moment(date).format("DD-MMM-YYYY") : "";
};

const getTuitionDefault = (row) =>
  row.updatedConcession ??
  row.orgTutionFeeConcession ??
  row.tutionFeeConcession ??
  0;

const ProspectusConcession = (props) => {
  const {
    userPermissions,
    applicationDetails,
    feeComps,
    prospectusSlabs,
    setProspectusSlabs,
    allSlabs,
    setAllSlabs,
    setRowsCountInEditMode,
    allCategories,
    open,
    setOpen,
    categoryCodeData,
    rowsCountInEditMode,
    disableActions,
    isConcessionDisabled,
    customSlab,
    mapGlobalFeeComponents,
    extraComponent,
    setEditFormOpen,
    setDefinedConcessionDirty,
    freezeAction,
    customConfig,
    fee,
    allAppliedConcList,
    isDisableConcession,
    forCentralizedAdmission,
    concessionModificationAllowed,
    groupedBreakUp,
    paidItems,
    studentCurrentYear,
    isTransferredStudent = false,
    setCustomSlab,
    setConcessionDetails,
  } = props;
  console.log(prospectusSlabs, "prospectusSlabs");

  let { id, action } = useParams();

  const [remarks, setRemarks] = useState(null);
  const [openRemarksDialogue, setOpenRemarksDialogue] = useState(false);

  const onChangeHandler = (row, value) => {
    const numVal = parseFloat(value);
    const currentDefineConcessionList = [...prospectusSlabs];
    const concessionId = row?.concessionSlabId;
    const currentConcessionIndex = currentDefineConcessionList.findIndex(
      (item) => item.concessionSlabId === concessionId
    );
    const currentConcession =
      currentDefineConcessionList[currentConcessionIndex] || row;
    const maxConcession =
      currentConcession?.orgOldTutionFeeConcession ||
      currentConcession.orgTutionFeeConcession ||
      currentConcession.tutionFeeConcession;

    if (value !== "") {
      if (numVal > maxConcession) {
        return; // Do not update state
      }

      if (numVal < 0) {
        return;
      }
    }

    currentDefineConcessionList[currentConcessionIndex]["updatedConcession"] =
      value;

    setProspectusSlabs(currentDefineConcessionList);
  };
  const getFilteredCodeCategory = (params) => {
    const usedCategory = {};
    prospectusSlabs.forEach((element) => {
      if (
        element.action !== "DELETE" &&
        element?.id !== params?.id &&
        element?.code?.[0]?.value
      ) {
        usedCategory[element.code?.[0]?.value] =
          (usedCategory[element.code?.[0]?.value] || 0) + 1;
      }
    });
    const filteredOption = categoryCodeData.filter((code) => {
      const { value, frequency } = code;
      return !usedCategory?.[value] || usedCategory[value] < frequency;
    });

    return filteredOption || [];
  };

  const isDisabled = (param) => {
    if(concessionModificationAllowed === false && !param.isNew) return true;
    return param?.concessionMethodType?.split("_")?.[0] === "AUTO"
      ? true
      : false;
  };

  const validateLumSumpOutstanding = (lupSumType) => {
    // if not the lupSumType then bypass the validation
    if (!lupSumType) return true;
    return calculateOutstanding(
      groupedBreakUp,
      paidItems,
      lupSumType,
      studentCurrentYear
    );
  };

  const columns = useMemo(() => {
    return [
      {
        field: "code",
        headerName: "Code",
        flex: 0.5,
        minWidth: 66,
        type: "singleSelect",
        mandatory: true,
        editable: true,
        disabled: false,
        getIsFeildDisabled: (row) => isDisabled(row),
        valueOptionsGetter: (params) => {
          return getFilteredCodeCategory(params);
        },
        placeHolder: "",
        affects: ["category"],
        sortable: false,
      },
      {
        field: "category",
        headerName: "Category",
        flex: 1,
        minWidth: 140,
        mandatory: true,
        editable: true,
        disabled: false,
        sortable: false,
        renderCell: (params) => (
          <div className="w-100 d-flex">
            <span
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "85%",
              }}
            >
              {params.value?.subSubCategoryDisplayValue ??
                params.value?.subCategoryDispVal ??
                params.value?.displayVal}
            </span>
            {(params.value?.subSubCategoryDesc ??
              params.value?.subCategoryDesc ??
              params.value?.categoryDesc) && (
              <LightTooltip
                className="p-0"
                title={
                  <CategoryDetailsCard
                    code={params.value?.categoryCode}
                    categoryName={params.value?.categoryDispVal}
                    subCategoryName={params.value?.subCategoryDispVal}
                    subSubCategoryName={
                      params.value?.subSubCategoryDisplayValue
                    }
                    description={
                      params.value?.subSubCategoryDesc ??
                      params.value?.subCategoryDesc
                    }
                  />
                }
              >
                <div style={{ cursor: "pointer" }}>
                  <AiOutlineEye className="ml-1" size={16} color="#11cdef" />
                </div>
              </LightTooltip>
            )}
          </div>
        ),
        renderEditCell: (params) => (
          <CategorySelector
            validateLumSumpOutstanding={validateLumSumpOutstanding}
            allAppliedConcList={allAppliedConcList}
            applicationDetails={applicationDetails}
            allCategories={allCategories}
            {...params}
            userPermissions={userPermissions}
            prospectusSlabs={prospectusSlabs}
            isCategorySelectorDisabled={isDisabled}
            concessionModificationAllowed={concessionModificationAllowed}
          />
        ),
      },

      {
        field: "concessionSlabId",
        headerName: "Concession Slab Id",
        width: 10,
        mandatory: false,
        editable: true,
        hide: true,
      },
      {
        field: "adminFeeConcession",
        headerName: "Admission Fee",
        width: 10,
        mandatory: false,
        editable: true,
        hide: true,
      },
      {
        field: "regFeeConcession",
        headerName: "Reg Fee",
        width: 10,
        mandatory: false,
        editable: true,
        hide: true,
      },
      {
        field: "classFeeConcession",
        headerName: "Class Fee",
        width: 10,
        mandatory: false,
        editable: true,
        hide: true,
      },
      {
        field: "techFeeConcession",
        headerName: "Tech Fee",
        width: 10,
        mandatory: false,
        editable: true,
        hide: true,
      },
      {
        field: "tutionFeeConcession",
        headerName: "Tution Fee",
        width: 10,
        mandatory: false,
        editable: true,
        hide: true,
      },
      {
        field: "isNewSlab",
        headerName: "Concession Paramater Value Updated",
        width: 10,
        mandatory: false,
        editable: true,
        hide: true,
      },

      {
        field: "scholarship",
        headerName: "Scholarship",
        flex: 1,
        width: 120,
        minWidth: 105,
        editable: true,
        sortable: false,
        renderCell: (params) => (
          <div className="d-flex">
            {getConcessionPercent(params.row, fee)}
            %
            <AppliedConcessionSummary
              feeComps={feeComps}
              prospectusSlabs={prospectusSlabs}
              allSlabs={allSlabs}
              fee={fee}
              row={params.row}
            />
          </div>
        ),
        renderEditCell: (params) => {
          if (!params.row.id || params.row.isNew || params.row.isNewSlab)
            return <div>-</div>;
          return (
            <div className="scholarship-percentage">
              <CommonInput
                type={"text"}
                regEx={regex.numericDecimal}
                maxLength={100}
                forTable={true}
                allowDecimalvalue={true}
                defaultValue={getTuitionDefault(params.row)}
                placeHolder={"-"}
                onChange={(val) => {
                  if (+val > 100 || String(val).split(".")[1]?.length > 2) {
                    return;
                  }
                  onChangeHandler(params.row, val);
                  params.api.setEditCellValue({
                    id: params.id,
                    field: params.field,
                    value: val,
                  });
                }}
              />
            </div>
          );
        },
      },
      ...(isNewTermStudent(applicationDetails)
        ? [
            {
              field: "progressive",
              headerName: "Progressive",
              flex: 1,
              width: 90,
              minWidth: 120,
              mandatory: false,
              editable: false,
              sortable: false,
              renderCell: (params) => (
                <ViewProgressiveConcessionBreakup
                  feeComps={feeComps}
                  {...params}
                  allSlabs={allSlabs}
                  extraComponent={[...extraComponent]}
                  fee={fee}
                />
              ),
              renderEditCell: (params) => (
                <ViewProgressiveConcessionBreakup
                  feeComps={feeComps}
                  {...params}
                  allSlabs={allSlabs}
                  extraComponent={[...extraComponent]}
                  fee={fee}
                />
              ),
            },
          ]
        : []),
      {
        field: "remarks",
        headerAlign: "center",
        align: "center",
        headerName: "Remarks",
        flex: 1,
        width: 100,
        type: "text",
        mandatory: false,
        editable: true,
        disabled: false,
        sortable: false,
        placeHolder: "Add",
        renderCell: (params) => (
          <div
            className="w-100 d-flex custom-concession-cell"
            style={{ justifyContent: "center", paddingRight: "14px" }}
          >
            <span
              onClick={() =>
                fetchRemarks(
                  applicationDetails.applicationId,
                  setRemarks,
                  setOpenRemarksDialogue,
                  params?.row?.id
                )
              }
              style={{ color: "#00B0F5", cursor: "pointer" }}
            >
              View
            </span>
          </div>
        ),
      },
      {
        field: "concessionDocuments",
        headerAlign: "center",
        headerName: "Documents",
        flex: 1,
        minWidth: 100,
        mandatory: false,
        editable: true,
        disabled: false,
        sortable: false,
        renderCell: (params) => (
          <SupportingDocUploader
            userPermissions={userPermissions}
            params={params}
            viewOnly={true}
            viewText={true}
          />
        ),
        renderEditCell: (params) => (
          <SupportingDocUploader
            userPermissions={userPermissions}
            params={params}
            viewOnly={false}
          />
        ),
        initialValue: [],
      },
      {
        field: "appliedOn",
        headerName: "Applied on",
        flex: 1.5,
        minWidth: 150,
        mandatory: false,
        editable: true,
        disabled: false,
        sortable: false,
        renderCell: (params) => (
          <LightTooltip title={getFormatedDateTime(params.value)}>
            <div style={{ cursor: "pointer" }}>
              <span>{getFormatedDate(params.value)}</span>
            </div>
          </LightTooltip>
        ),
        renderEditCell: (params) => <span>-</span>,
      },
      {
        field: "status",
        headerName: "Status",
        flex: 1,
        minWidth: 120,
        mandatory: false,
        editable: false,
        disabled: false,
        sortable: false,
        renderCell: (params) => {
          const getApprPercentage = (status) => {
            switch (status) {
              case "L1_APPROVED":
                return customConfig?.l1ApprovalPercentage || "";
              case "L2_APPROVED":
                return customConfig?.l2ApprovalPercentage || "";
              default:
                return "";
            }
          };

          const percent = params.row.isApproved
            ? 0
            : getApprPercentage(params.value);
          const val = params.row.isApproved
            ? "Approved"
            : `${percent ? percent + "% " : ""}${
                NEW_APPROVAL_STATUS?.[params.value] ?? ""
              }`;

          return params.row?.hasExtraFee ? (
            <div className="w-100 d-flex custom-concession-cell">
              <LightTooltip title={val}>
                <div
                  className="d-flex"
                  style={{ marginTop: "0px", width: "90%" }}
                >
                  <span
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "100%",
                      whiteSpace: "nowrap",
                      padding: ["Approved", "Rejected", "Recheck"].includes(val)
                        ? "2px 10px"
                        : "2px 10px",
                      borderRadius: "4px",
                      backgroundColor:
                        STATUS_DATA[val]?.BCOLOR ?? (val ? "#CCEFFD" : ""),
                    }}
                  >
                    {val}
                  </span>
                </div>
              </LightTooltip>
            </div>
          ) : (
            <div className="w-100 d-flex custom-concession-cell">NA</div>
          );
        },
        renderEditCell: (params) => (
          <div className="custom-concession-cell">-</div>
        ),
        value: customSlab.status,
      },
      {
        field: "concessionParameter",
        headerName: "Concession Parameter",
        width: 50,
        mandatory: false,
        editable: true,
        hide: true,
      },
      {
        field: "scholarshipCriteria",
        headerName: "Scholarship Criteria Fee",
        width: 50,
        mandatory: false,
        editable: true,
        hide: true,
      },
      {
        field: "scholarshipCriteriaValue",
        headerName: "Scholarship Criteria Value",
        width: 50,
        mandatory: false,
        editable: true,
        hide: true,
      },
      {
        field: "categoryId",
        headerName: "CategoryId",
        width: 50,
        mandatory: false,
        editable: true,
        hide: true,
      },
      {
        field: "concessionMethodType",
        headerName: "concessionMethodType",
        width: 50,
        mandatory: false,
        editable: true,
        hide: true,
      },
    ];
  }, [prospectusSlabs, feeComps]);

  const onRowDelete = (slab) => {
    const slabPresent = allSlabs.find((row) => row.id === slab.id); //slabToDelete
    // const prevDeletedSlabs = allSlabs?.filter(slab => slab?.action === 'DELETE');
    // const otherProspectusSlabs = prospectusSlabs?.filter(pS => pS?.id !== slab?.id)?.map(slab => ({...slab , action : slab?.fromBE ? 'UPDATE' : 'CREATE' })); //as we need to update

    // const {definedConcessions, customConcessions} = getProgressiveConcessionListWithCustom(
    //   otherProspectusSlabs,
    //   fee,
    // //   customSlab?.[0]
    // null
    // )
    // setProspectusSlabs(definedConcessions);

    if (slabPresent) {
      if (slabPresent.action === "CREATE") {
        setAllSlabs((slabs) =>
          slabs.filter((row) => row.id !== slabPresent.id)
        );
        // setAllSlabs([...definedConcessions, ...prevDeletedSlabs])
      } else if (slabPresent.action === "UPDATE") {
        setAllSlabs((slabs) =>
          slabs.map((row) =>
            row.id === slabPresent.id
              ? { ...slab, action: "DELETE", concessionType: "DEFINED" }
              : row
          )
        );
        // setAllSlabs([...definedConcessions, ...prevDeletedSlabs, {...slab, action : "DELETE" , concessionType : "DEFINED"}])
      }
      setDefinedConcessionDirty(true);
    } else {
      setAllSlabs((slabs) => [
        ...slabs,
        { ...slab, action: "DELETE", concessionType: "DEFINED" },
      ]);
      // setAllSlabs([...definedConcessions, ...prevDeletedSlabs, {...slab, action : "DELETE" , concessionType : "DEFINED"}])
    }
    setDefinedConcessionDirty(true);
    mapGlobalFeeComponents(prospectusSlabs.filter((row) => row.id !== slab.id));
    // mapGlobalFeeComponents(definedConcessions);
  };

  const frequencyValidation = (arr) => {
    //console.log(arr)
    const frequencyMap = {};
    for (const obj of arr) {
      if (obj?.code?.[0]) {
        const { value, frequency } = obj.code[0];
        if (obj.action !== "DELETE" && obj.concessionType) {
          if (!frequencyMap.hasOwnProperty(value)) {
            frequencyMap[value] = 1;
          } else {
            frequencyMap[value] += 1;
          }
        }
        if (frequencyMap[value] > frequency) {
          failureToast("Frequency of code exceeds the provided frequency");
          return false;
        }
      }
    }

    for (const obj of arr) {
      if (obj?.code?.[0]?.notAllowedCombination) {
        const combinations = obj.code?.[0]?.notAllowedCombination?.split(",");
        let isAllPresent = true;
        combinations.map((i) => {
          if (!frequencyMap.hasOwnProperty(i)) {
            isAllPresent = false;
          }
        });
        if (isAllPresent) {
          failureToast("Combination not allowed");
          return false;
        }
      }
    }
    return true;
  };

  const resolveOldValue = (item, keys) =>
    item[keys[0]] || item[keys[1]] || item[keys[2]] || 0;

  const saveSlab = (slab) => {
    // [Validation - Same as before]
    if (Number(slab["updatedConcession"]) === 0) {
      failureToast(
        "Concession percentage can not be ZERO. Please delete the row to continue."
      );
      return Promise.reject("Concession cannot be zero");
    }
    // is already 100 concession
    // if(isAlreadyAboveLimit(prospectusSlabs)){
    //   failureToast("Already 100% concession added");
    //   return Promise.reject("Concession cannot be 100+");
    // }

    // [Create Base Slab - Same as before]
    let _slab = {
      ...slab,
      updatedOn: new Date(),
      action: slab.fromBE && !slab.isAutoConcession ? "UPDATE" : "CREATE",
      concessionType: "DEFINED",
      isDirty: true,
      isNew: true,
    };

    // ---------------------------------------------------------
    // 1. INJECTED FIX: Calculate Fee Values BEFORE creating newRows
    // This replaces your updateConcessionDetails call
    // ---------------------------------------------------------
    if (slab["updatedConcession"]) {
      const value = slab["updatedConcession"];

      const oldClassFee = resolveOldValue(_slab, [
        "orgOldClassFeeConcession",
        "orgClassFeeConcession",
        "classFeeConcession",
      ]);
      const oldTuitionFee = resolveOldValue(_slab, [
        "orgOldTutionFeeConcession",
        "orgTutionFeeConcession",
        "tutionFeeConcession",
      ]);
      const updatedValues = isNewTermStudent(applicationDetails)
        ? {}
        : { tutionFeeConcession: value, classFeeConcession: value };

      _slab = {
        ..._slab,
        orgOldClassFeeConcession: oldClassFee,
        orgOldTutionFeeConcession: oldTuitionFee,
        orgClassFeeConcession: value,
        orgTutionFeeConcession: value,
        updatedConcession: value,
        ...updatedValues,
      };
    }
    // ---------------------------------------------------------

    // [List Management - Same as before]
    const rows = allSlabs.filter((row) => row.id !== _slab.id);
    let newRows = [...rows, _slab]; // Now _slab has the updated values

    const fromBe = prospectusSlabs.filter((row) => row.fromBE);

    const newRowsWithCourseCategoryInformation = newRows.map((i) => {
      if (!i?.fromBE) return i;
      const newCode = categoryCodeData.filter(
        (c) => i.code?.[0]?.value === c.value
      );
      return { ...i, code: newCode };
    });

    const isDataValid = frequencyValidation(
      newRowsWithCourseCategoryInformation
    );

    if (isDataValid) {
      // [State Updates - Same as before]
      setAllSlabs(newRows);
      setRowsCountInEditMode((count) => count - 1);
      setEditFormOpen(false);
      mapGlobalFeeComponents(newRows);

      // ---------------------------------------------------------
      // 2. INJECTED FIX: Handle "New Row" Matching in State
      // We added '|| item.id === _slab.id' so new rows don't get ignored
      // ---------------------------------------------------------
      setProspectusSlabs(
        (prevSlabs) =>
          getProgressiveConcessionListWithCustom(
            prevSlabs.map((item) =>
              item.concessionSlabId === _slab.concessionSlabId ||
              item.id === _slab.id
                ? _slab
                : item
            ),
            fee
          )["definedConcessions"]
      );

      setDefinedConcessionDirty(true);

      // ---------------------------------------------------------
      // 3. INJECTED FIX: Generate Calculated Nested Object for MuiTable
      // We run the calculator LOCALLY just to patch the return object
      // so the table shows the correct 'progressiveConcession' immediately.
      // ---------------------------------------------------------

      // We create a temporary list to calculate the progressive values correctly
      const tempCalcList = prospectusSlabs.map((item) =>
        item.concessionSlabId === _slab.concessionSlabId || item.id === _slab.id
          ? _slab
          : item
      );

      const calculatedResult = getProgressiveConcessionListWithCustom(
        tempCalcList,
        fee
      );
      const calculatedRow = calculatedResult.definedConcessions.find(
        (item) =>
          item.concessionSlabId === _slab.concessionSlabId ||
          item.id === _slab.id
      );

      // Return the Calculated Row (which has the correct nested object)
      return Promise.resolve(calculatedRow || _slab);
    } else {
      return Promise.reject("Validation failed");
    }
  };

  const closeTableForm = () => {
    setRowsCountInEditMode(0);
    setEditFormOpen(false);
  };

  const headerComp = (
    <Row
      onClick={() => {
        setOpen((prev) => ({ ...prev, propspectus: !prev.propspectus }));
        if (open) closeTableForm();
      }}
      className="prospectus-header pt-3 cursor"
    >
      <div className="prospectus-header-title">
        <h3>Defined concession</h3>
      </div>
    </Row>
  );

  const headerRight = (
    <MdKeyboardArrowUp
      className="cursor"
      onClick={() => {
        setOpen((open) => ({ ...open, propspectus: false }));
        closeTableForm();
      }}
      size={26}
    />
  );
  return (
    <div className="propectus-concession">
      {open ? (
        <>
          <MuiTable
            actionSeperatorRequired={false}
            rows={prospectusSlabs}
            columns={columns}
            headerComp={headerComp}
            headerMiscellaneousRightComp={headerRight}
            userPermissions={userPermissions}
            loading={false}
            onRowDelete={onRowDelete}
            asyncSaveRow={saveSlab}
            useDeleteIconForCancel={true}
            onRowChange={(rows) => {
              setProspectusSlabs(rows);
            }}
            extraHeight={0}
            // maxHeight={168}
            onEditClick={() => {
              setRowsCountInEditMode((count) => count + 1);
              setEditFormOpen(true);
            }}
            onCancelClick={(id) => {
              let slab = prospectusSlabs.find((sl) => sl?.id === id);
              setRowsCountInEditMode((count) => count - 1);
              setEditFormOpen(false);
            }}
            onAddRewRow={() => {
              setRowsCountInEditMode((count) => count + 1);
              setEditFormOpen(true);
            }}
            readOnly={
              isTransferredStudent ||
              action === "view" ||
              disableActions ||
              freezeAction ||
              isDisableConcession ||
              forCentralizedAdmission
            }
            pageSize={100}
            disableVirtualization={true}
            rowsCountInEditMode={rowsCountInEditMode}
            newRowLabel={"Add Concession"}
            isTransferredStudent={isTransferredStudent}
            defaultEditRowId={""}
            concessionModificationAllowed={true}
            isAllowForEdit={
              action === "view" ||
              disableActions ||
              freezeAction ||
              isDisableConcession ||
              forCentralizedAdmission
            }
            readOnlyButAllowNewRow={true}
          />
          {/* <GetDisplayData customSlab={customSlab}/> */}
          <RemarksDialogue
            remarksData={remarks}
            open={openRemarksDialogue}
            setOpen={setOpenRemarksDialogue}
            setRemarksData={setRemarks}
          />
        </>
      ) : (
        <Row
          onClick={() =>
            setOpen((prev) => ({ ...prev, propspectus: !prev.propspectus }))
          }
          className="prospectus-header-collapsed py-3 cursor"
        >
          <div className="prospectus-header-title">
            <h3>Defined concession</h3>
          </div>
          <MdKeyboardArrowDown
            size={26}
            onClick={(e) => {
              e.stopPropagation();
              setOpen((prev) => ({ ...prev, propspectus: true }));
            }}
          />
        </Row>
      )}
    </div>
  );
};

export default ProspectusConcession;
